import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ContactForm } from '@metlas/contact';
import './PropertyManagement.css';

const ROTATING_PHRASES = [
  'better sale strategy.',
  'faster lead qualification.',
  'tailored recommendations.',
  'seamless CRM experience.',
  'smarter market insights.',
  'data-driven pricing.',
];

const CASE_STUDIES = [
  {
    slug: '/property-management/app',
    title: 'Property management',
    quote:
      'Leases, rent, repairs and renewals used to live in five different places. Now our tenants handle most of it themselves in the app, and the to-dos and reminders it manages for us mean nothing slips through the cracks.',
    role: 'Property Manager',
    company: 'LMT Homes Corporation',
  },
  {
    slug: '/property-management/lead-acquisition',
    title: 'Lead acquisition',
    quote:
      'Most of our leads are Chinese international students messaging at 2 a.m. New York time, often in Chinese. The assistant answers instantly in their language and books tours straight onto our calendar. We stopped losing leads overnight.',
    role: 'Founder',
    company: 'NYC rental brokerage serving Chinese international students',
  },
  {
    slug: '/property-management/competitor-analysis',
    title: 'Competitor analysis',
    quote:
      'We used to spend 20 hours a week manually pulling competitive analysis on local rent trends and building concessions. The custom agent brought that down to 10 minutes, with 100% accurate market data, not hallucinations.',
    role: 'Leasing Manager',
    company: 'Leading NYC Real Estate Developer, 5,000+ Units',
  },
];

const PropertyManagement: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setPhraseIndex((prev) => (prev + 1) % ROTATING_PHRASES.length);
        setIsFading(false);
      }, 400);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="re-page">
      <div className="re-bg">
        <div className="re-nebula re-nebula-1" />
        <div className="re-nebula re-nebula-2" />
        <div className="re-nebula re-nebula-3" />
      </div>

      <div className={`re-content ${isVisible ? 'visible' : ''}`}>
        <nav className="re-nav">
          <Link to="/" className="re-back">
            ← Back to Metlas
          </Link>
        </nav>

        <section className="re-hero">
          <h1 className="re-headline">
            An AI-native solution for property management,{' '}
            <span className={`re-rotating ${isFading ? 'fade-out' : 'fade-in'}`}>
              {ROTATING_PHRASES[phraseIndex]}
            </span>
          </h1>
        </section>

        <section className="re-case-studies">
          <h2 className="re-case-study-title">Case Studies</h2>
          <div className="re-cs-grid">
            {CASE_STUDIES.map((cs) => (
              <article key={cs.slug} className="re-cs-card">
                <h3 className="re-cs-card-title">{cs.title}</h3>
                <p className="re-cs-quote">{cs.quote}</p>
                <p className="re-cs-attrib">
                  <span className="re-cs-role">{cs.role}</span>
                  <span className="re-cs-company">{cs.company}</span>
                </p>
                <Link className="re-cs-demo-btn" to={cs.slug}>
                  See demo →
                </Link>
              </article>
            ))}
          </div>
        </section>
      </div>

      <aside className="re-contact-float">
        {contactOpen ? (
          <div className="re-contact-panel">
            <button
              type="button"
              className="re-contact-close"
              onClick={() => setContactOpen(false)}
              aria-label="Close contact form"
            >
              ✕
            </button>
            <ContactForm variant="float" />
          </div>
        ) : (
          <button
            type="button"
            className="re-contact-pill"
            onClick={() => setContactOpen(true)}
          >
            Book a Demo
          </button>
        )}
      </aside>
    </div>
  );
};

export default PropertyManagement;
